import { Component, OnInit } from '@angular/core';
import { MainPortalService } from '../../../services/main-portal.service';
import { GenericFiltrationContract } from 'projects/shared/models/GenericFiltrationContract';
import { Globals } from 'projects/shared/models/Globals';

declare var parentId: any;
declare var isChild: any;
declare var isEshop:any;
declare var productKey:any;
@Component({
  selector: 'app-related-products',
  templateUrl: './related-products.component.html',
  styleUrls: []
})

export class RelatedProductsComponent implements OnInit {
  public items: any[] = new Array();
  static pageIndex = 1;
  input = new GenericFiltrationContract(parentId, RelatedProductsComponent.pageIndex, 4, Globals.SecondaryListingCrop, 250);
  globals;
  hideShowMoreButton = false;
  isChild = isChild;
  
  constructor(private data: MainPortalService) 
  { 
    this.globals = Globals;
  }

  ngOnInit() {
    this.input.productKey=productKey;
    this.data.GetContentRelatedProducts(this.input).subscribe((response: any) =>{
      this.items = response
    });
  }


}
